module.exports = __webpack_public_path__ + "static/media/info10_Sede_examen.32c39801.png";